import { api } from "@/src/services/api/interceptor.client";
import { tokenService } from "./token.service";
import {
  LoginRequest,
  LoginTransportRequest,
  LoggedResponse,
  PasswordPublicKeyData,
} from "../../types/request-response.types";

const pemToArrayBuffer = (pem: string) => {
  const base64 = pem
    .replace(/-----BEGIN PUBLIC KEY-----/g, "")
    .replace(/-----END PUBLIC KEY-----/g, "")
    .replace(/\s/g, "");
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return bytes.buffer;
};

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = "";

  for (let index = 0; index < bytes.byteLength; index += 1) {
    binary += String.fromCharCode(bytes[index]);
  }

  return btoa(binary);
};

const encryptPassword = async (password: string) => {
  const keyResponse = await api.get<{ data: PasswordPublicKeyData }>(
    "/auth/password-public-key"
  );
  const publicKey = await crypto.subtle.importKey(
    "spki",
    pemToArrayBuffer(keyResponse.data.data.publicKey),
    {
      name: "RSA-OAEP",
      hash: "SHA-256",
    },
    false,
    ["encrypt"]
  );
  const encrypted = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    publicKey,
    new TextEncoder().encode(password)
  );

  return arrayBufferToBase64(encrypted);
};

export const authService = {
  login: async (
    payload: LoginRequest
  ): Promise<LoggedResponse> => {
    const transportPayload: LoginTransportRequest = {
      email: payload.email,
      encryptedPassword: await encryptPassword(payload.password),
    };

    const response = await api.post(
      "/auth/login",
      transportPayload
    );

    tokenService.setToken(
      response.data.data.token
    );

    return response.data;
  },

  logout: async () => {
    await api.post("/auth/logout");
  },

  me: async () => {
    const response = await api.get("/auth/me");
    return response.data;
  },

  list: async () => {
    const response = await api.get("/auth/list?t=1");
    return response.data;
  }
};
